import React from "react";
import './Styles/About.css';
import Tilt from 'react-parallax-tilt';
import ajinkyaport1 from './Images/ajinkyaport1.png';
import Timeline from "./Timeline";
import Github from "./Github";

const About = () => {
    return (
        <>
            <div id="About">
                <Tilt gyroscope={true} className="tilt_title">
                    
                    <div className="img_card" data-aos="zoom-in">
                        <img src={ajinkyaport1} alt="Ajinkya's Profile" style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px'}} />
                    </div>
                </Tilt>

                <div className="info-title" data-aos="zoom-in">
                    <h2 data-aos="zoom-in" className="about-title-mobile">About <span className="prof">Me</span></h2>
                    
                    <p className="about-text">
                    I’m Ajinkya Patil, a Final Year B.E. IT student at VESIT with Total <strong>12 months of experience</strong> in Different Tech Stack such as <strong>Full-Stack Development</strong>, <strong>AI/ML</strong>, and <strong>Data Analytics</strong>. Skilled in the <strong>MERN Stack</strong>, <strong>Python</strong> (Flask), and <strong>Java</strong> (Spring Boot, JavaFX), with a strong interest in <strong>Data Analytics & Devops</strong>. I also contribute as a <strong>Local Chapter Lead at Robin Hood Army</strong> and an Head member of <strong>Tech Councils</strong>.
                    </p>

                    <p className="about-text">
                        I turn ideas into impactful digital products — from web platforms to AI/ML models and enterprise systems.<br></br>
                        Check out <a href="/#Skills" className="arrowLink">Softwares and Tools</a> I use.
                    </p>
                    <div className="msg-btn">
                        <a href="/resume.pdf" id="download" download='AjinkyaResume'>Download CV <i className="fa-solid fa-arrow-right"></i></a>
                        <a href="/#Contact" className="btnA">Let's Talk <i className="fa-solid fa-arrow-right"></i></a>
                    </div>

                   {/* ----------- Experience Section ----------- */}
<h2 data-aos="zoom-in">Internship <span className="prof">Experience</span></h2>

<table className="experience-table about-text">
  <thead>
    <tr>
      <th>Role(3-Months)</th>
      <th>Company</th>
      <th>Certificate</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><strong>Data Analyst Intern</strong></td>
      <td>InternCourse</td>
      <td>
        <a href="https://drive.google.com/file/d/1qZjmOA8VkWbNJ81Lmzsj0Qkdbki-HJDw/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="arrowLink">
          <i className="fa-solid fa-link"></i>
        </a>
      </td>
    </tr>
    <tr>
      <td><strong>AI/ML + Full Stack Developer</strong></td>
      <td>Shivraj Enterprises</td>
      <td>
        <a href="https://drive.google.com/file/d/110RS5-Tfo9UjaRlH0ZOSfqUU6Lzzv5s1/view" target="_blank" rel="noopener noreferrer" className="arrowLink">
          <i className="fa-solid fa-link"></i>
        </a>
      </td>
    </tr>
    <tr>
      <td><strong>Full Stack Developer</strong></td>
      <td>Palcoa Solutions</td>
      <td>
        <a href="https://drive.google.com/file/d/1klVkUViaoan8D6lVhfDFphMLZaMohLeJ/view" target="_blank" rel="noopener noreferrer" className="arrowLink">
          <i className="fa-solid fa-link"></i>
        </a>
      </td>
    </tr>
    <tr>
      <td><strong>Full Stack Developer</strong></td>
      <td>Zidio Development</td>
      <td>
        <a href="https://drive.google.com/file/d/1u03z0APxVJytQQSiS5L4NIqYDlnncx5y/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="arrowLink">
          <i className="fa-solid fa-link"></i>
        </a>
      </td>
    </tr>
  </tbody>
</table>
{/* ----------- End Experience Section ----------- */}


                    
                </div>
            </div>

            <Timeline/>
            <Github/>
        </>
    )
}
export default About;
